import React, { useState } from "react";
import { navigate } from "gatsby";
import $ from 'jquery'

function SearchResultsPagination(props) {
    const [pagenumber, setPageNumber] = useState(props.current_page_number);

    const prevpage = event => {
        if ((props.current_page_number > 1)) {
            setPageNumber((props.current_page_number) - 1)
            let pageUrl = 'page-' + ((props.current_page_number) - 1) + '/';
            //get current url
            const urlwithoutsort = (props?.location_path).split("page-");
            // concat url and navigate
            if (props.current_page_number == 1) {
                navigate(urlwithoutsort[0])
            }
            else {
                navigate(urlwithoutsort[0] + pageUrl)
            }
            var target = $("body");
            $('html,body').animate({
                scrollTop: target.offset().top - 250
            }, 100);
        }


    }
 
    return (
        <React.Fragment>
            {props.total > 9 &&
                <section className="more-results">
                    <div className="more-btn">
                        <button
                            className={`more ${(props.current_page_number > 1) ? "active" : "disable"} `}
                            id="mynextbut"
                            onClick={prevpage}
                        // disabled={!hasMore}
                        >
                            <i className="icon-chevron-left"></i>  Back
                        </button>
                    </div>
                </section>
            }
        </React.Fragment>
    );
}

export default SearchResultsPagination